export default {"src":"/planos/_next/static/media/equifax-light-bulb.9e4dcadb.svg","height":24,"width":18,"blurWidth":0,"blurHeight":0};